import { useFormikContext } from 'formik';
import React, { useEffect } from 'react';
import EntityFormContext from './EntityFormContext';
const EntityFormContent = ({ fieldWrapperClassNames = {}, isEditing = false, children, ...props }) => {
    const { resetForm, ...context } = useFormikContext();
    useEffect(() => () => {
        if (isEditing) {
            resetForm();
        }
    }, [isEditing, resetForm]);
    return (<EntityFormContext.Provider value={{
        fieldWrapperClassNames,
        isEditing,
        ...props,
        resetForm,
        ...context,
    }}>
      {children}
    </EntityFormContext.Provider>);
};
export default EntityFormContent;
